import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { PATHS } from '../utils/utils';
import { DashboardLayout, WithoutHeader } from './DashboardLayout';
import { useSelector } from 'react-redux';
import Sitemap from '../pages/Sitemap.jsx';


export const Loadable = (Component) => (props) => (
    <Suspense fallback={<></>}>
        <Component
            {...props} />
    </Suspense>
);

const Header = Loadable(lazy(() => import("../components/Header")));
const Footer = Loadable(lazy(() => import("../components/Footer")));

export { Header, Footer };

const HomePage = Loadable(lazy(() => import('../pages/HomePage/HomePage')));
const Login = Loadable(lazy(() => import('../pages/Auth/Login')));
const OtpPage = Loadable(lazy(() => import('../pages/Auth/OtpPage')));
const IPODashboardPage = Loadable(lazy(() => import('../pages/HomePage/IPODashboardTable')));
const IPODetailsPage = Loadable(lazy(() => import('../pages/IPO/IPODetailsPage')));
const IpoSubscriptionInner = Loadable(lazy(() => import('../components/ipoSubscriptionInner')));
const ForgotPassword = Loadable(lazy(() => import('../pages/Auth/ForgotPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/Auth/VerifyCode')));
const SetPassWord = Loadable(lazy(() => import('../pages/Auth/SetPassWord')));
const BrokerPage = Loadable(lazy(() => import('../pages/Broker/BrokerPage')));
const NewsPage = Loadable(lazy(() => import('../pages/News/NewsPage')));
const AboutUs = Loadable(lazy(() => import('../pages/CmsPage/AboutUs')));
const UpcomingIpoPage = Loadable(lazy(() => import('../pages/IPO/UpcomingIpoPage')));
const ListedIpoPage = Loadable(lazy(() => import('../pages/IPO/ListedIpoPage')));
const CurrentIpoPage = Loadable(lazy(() => import('../pages/IPO/CurrentIpoPage')));
const AppPrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/AppPrivacyPolicyPage')));
const TermsAndConditionsPage = Loadable(lazy(() => import('../pages/CmsPage/TermsAndConditions.jsx')));
const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/PrivacyPolicyPage.jsx')));
const ContactUs = Loadable(lazy(() => import('../pages/CmsPage/ContactUs')));
const NewsDetail = Loadable(lazy(() => import('../pages/News/NewsDetail.jsx')));
const BrokerDetail = Loadable(lazy(() => import('../pages/Broker/BrokerDetail.jsx')));
const PrivacyPolicyIpoTrend = Loadable(lazy(() => import('../pages/CmsPage/PrivacyPolicyIpoTrend.jsx')));
const FAQsPage = Loadable(lazy(() => import('../pages/CmsPage/FAQs.jsx')));
const SiteMapPage = Loadable(lazy(() => import('../pages/SiteMapPage.jsx')));
const Android_AboutUs = Loadable(lazy(() => import('../pages/CmsPage/Android_AboutUs.jsx')));
const AndroidTermsAndConditions = Loadable(lazy(() => import('../pages/CmsPage/AndroidTermsAndConditions.jsx')));
const AndroidAppPrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/AndroidAppPrivacyPolicyPage.jsx')));
const AndroidContactUs = Loadable(lazy(() => import('../pages/CmsPage/AndroidContactUs.jsx')));
const DeleteAccount = Loadable(lazy(() => import('../pages/Auth/DeleteAccount.jsx')));
const ProfilePage = Loadable(lazy(() => import('../pages/Auth/ProfilePage.jsx')));
const AppliedIpoList = Loadable(lazy(() => import('../pages/IPO/AppliedIpoList.jsx')));
const ApplyPage = Loadable(lazy(() => import('../pages/IPO/ApplyPage.jsx')));
const ModifyAppliedIpo = Loadable(lazy(() => import('../pages/IPO/ModifyAppliedIpo.jsx')));

const MyRoutes = () => {

    const loginData = useSelector(state => state.loginProfile.loginData)
  

    return (
      
            <BrowserRouter>
                <Routes>
                    <Route element={<DashboardLayout />}>

                        <Route path={PATHS.HOME} element={<HomePage />} />
                        <Route path={PATHS.LOGIN} element={<Login />} />
                        <Route path={PATHS.OTPPAGE} element={<OtpPage />} />

                        <Route path={PATHS.IPODASHBOARD} element={<IPODashboardPage />} />
                        <Route path={PATHS.IPODETAILS} element={<IPODetailsPage />} />
                        <Route path={PATHS.IPO_DETAIL} element={<IpoSubscriptionInner />} />
                        <Route path={PATHS.IPO_DETAIL_ID} element={<IpoSubscriptionInner />} />
                        <Route path={PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
                        <Route path={PATHS.VERIFY_CODE} element={<VerifyCode />} />
                        <Route path={PATHS.SET_NEW_PASSWORD} element={<SetPassWord />} />
                        <Route path={PATHS.BROKER} element={<BrokerPage />} />
                        <Route path={PATHS.NEWS} element={<NewsPage />} />
                        <Route path={PATHS.ABOUT_US} element={<AboutUs />} />
                        <Route path={PATHS.LIVE} element={<CurrentIpoPage />} />
                        <Route path={PATHS.UPCOMING} element={<UpcomingIpoPage />} />
                        <Route path={PATHS.LISTED} element={<ListedIpoPage />} />
                        <Route path={PATHS.APP_PRIVACY_POLICY} element={<AppPrivacyPolicyPage />} />
                        <Route path={PATHS.TERMS_AND_CONDITIONS} element={<TermsAndConditionsPage />} />
                        <Route path={PATHS.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
                        <Route path={PATHS.CONTACT_US} element={<ContactUs />} />
                        <Route path={PATHS.MARKET_NEWS_DETAIL} element={<NewsDetail />} />
                        <Route path={PATHS.MARKET_NEWS_DETAIL_NAME} element={<NewsDetail />} />
                        <Route path={PATHS.BROKER_DETAIL} element={<BrokerDetail />} />
                        <Route path={PATHS.PRIVACY2} element={<PrivacyPolicyIpoTrend />} />
                        <Route path={PATHS.FAQS} element={<FAQsPage />} />
                        <Route path={PATHS.IPOSUBINNER} element={<IpoSubscriptionInner />} />
                        <Route path={PATHS.GOOGLE_SITE_MAP} element={<SiteMapPage />} />
                        <Route path={PATHS.NOT_FOUND} element={<Navigate to={PATHS.HOME} />} />
                        {loginData && (<>
                            <Route path={PATHS.PROFILE} element={<ProfilePage />} />
                            <Route path={PATHS.APPLIED_IPO} element={<AppliedIpoList />} />
                            <Route path={PATHS.APPLY} element={<ApplyPage />} />
                            <Route path={PATHS.MODIFY} element={<ModifyAppliedIpo />} />
                        </>)}
                        <Route path="*" element={<><h1>Page Not Found</h1></>} />
                    </Route>
                    <Route element={<WithoutHeader />}>
                        <Route path={PATHS.ANDROID_ABOUT_US} element={<Android_AboutUs />} />
                        <Route path={PATHS.ANDROID_TERMS_AND_CONDITIONS} element={<AndroidTermsAndConditions />} />
                        <Route path={PATHS.ANDROID_PRIVACY_POLICY} element={<AndroidAppPrivacyPolicyPage />} />
                        <Route path={PATHS.ANDROID_CONTACT_US} element={<AndroidContactUs />} />
                        <Route path={PATHS.DELETEACCOUNT} element={<DeleteAccount />} />
                        <Route path={PATHS.SITEMAP} element={<Sitemap />} />

                    </Route>
                </Routes>
            </BrowserRouter>

    );
};

export default MyRoutes;
